// Таймкод глав: хранится в секундах, редактируется как mm:ss / hh:mm:ss.

export function secondsToHms(total: number): string {
  const t = Math.max(0, Math.floor(total))
  const h = Math.floor(t / 3600)
  const m = Math.floor((t % 3600) / 60)
  const s = t % 60
  const ss = String(s).padStart(2, '0')
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${ss}`
  return `${m}:${ss}`
}

export function hmsToSeconds(input: string): number | null {
  const str = input.trim()
  if (!str) return null
  const parts = str.split(':')
  if (parts.length > 3) return null
  if (parts.some((p) => !/^\d+$/.test(p))) return null
  const nums = parts.map(Number)
  if (nums.length === 1) return nums[0]
  // последние две группы — минуты и секунды, должны быть 0..59
  const sec = nums[nums.length - 1]
  const min = nums[nums.length - 2]
  if (sec > 59 || min > 59) return null
  const hours = nums.length === 3 ? nums[0] : 0
  return hours * 3600 + min * 60 + sec
}

/**
 * Маска ввода времени главы: только цифры, не больше четырёх, двоеточие ставится
 * само — «1030» → «10:30», «103» → «10:3». Часов маска не даёт (до 99:59).
 */
export function maskMmSs(input: string): string {
  const d = input.replace(/\D/g, '').slice(0, 4)
  return d.length > 2 ? `${d.slice(0, 2)}:${d.slice(2)}` : d
}
